<script setup lang="ts"></script>

<template>
  <div class="auth-page">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.auth-page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: token("padding-medium");
  background: token("color-bg-canvas");
}
</style>
